import {
  ApplicationConfig,
  importProvidersFrom, provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import {provideRouter} from '@angular/router';

import { routes } from './app.routes';
import {JwtModule} from '@auth0/angular-jwt'
import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi
} from '@angular/common/http';
import {provideTranslateService} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {authHttpInterceptorFn, provideAuth0} from '@auth0/auth0-angular';
import {configInitializer} from './core/config/config-initializer';

export function tokenGetter() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let dataToken = urlParams.get('data');

  // We have to save the token in the local storage for the duration of the login flow.
  // We cannot use the appState because we cannot inject the AuthService to get to the appState before setting up the authConfig.
  if (dataToken) {
    sessionStorage.setItem('data_token', dataToken);
  } else {
    dataToken = sessionStorage.getItem('data_token');
  }
  return dataToken;
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAuth0(),
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([authHttpInterceptorFn])
    ),
    provideAppInitializer(() => {
      return configInitializer();
    }),
    importProvidersFrom(
      JwtModule.forRoot({
        config: {
          tokenGetter: tokenGetter,
          allowedDomains: [],
          disallowedRoutes: [],
        },
      }),
    ),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        useHttpBackend: true
      }),
      fallbackLang: 'en-ZA',
      lang: 'af-ZA',
    }),
    provideRouter(routes)
  ]
};
